<template>
  <div class="" style="min-height:50px">
    <div class="text-right" style="position: absolute; right: 10px; top: 5px">
      <font-awesome-icon :icon="['far', 'times']" @click="$emit('close')" style="cursor: pointer" class="text-hint" />
    </div>
    <div v-if="selected" class="d-flex text-secondary text-center">
      <div class="align-items-center w-100">
        You've selected
        <i>{{ selected.fullname}}</i>
        <br />
        <a @click="clear" href="javascript:void(0)" class="font-weight-bold">Clear Selection</a>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col ">
          <!-- <h6>Patient Search</h6> -->
          <div class="input-group input-group-lg ml-auto" style="max-width:400px">
            <input ref="searchInput" @keyup.enter="search" v-model="term" type="text" class="form-control text-center" placeholder="Search by last name" />
            <div class="input-group-append">
              <button type="button" @click="search" class="btn btn-primary" :disabled="isSearching">
                <font-awesome-icon icon="spinner-third" spin v-if="isSearching" />
                <font-awesome-icon :icon="['far', 'search']" v-else />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div v-if="results && !isSearching" class>
            <div class="row pt-2">
              <div class="col">
                <span class="text-muted" v-if="results.length < 200">
                  Found {{ results.length }} patient{{
                    results.length === 1 ? '' : 's'
                  }}
                  for
                  <i>{{ term }}</i>
                </span>
                <span class="text-muted" v-else>
                  Found more than {{ results.length }} patients for
                  <i>{{ term }}</i>. <b>Hint:</b> Try narrowing your search.
                </span>
              </div>
            </div>
            <div class="row py-3 bg-white rounded search-result-list">
              <!-- todo:// key should be concat of ids in group -->
              <div v-for="chunk in chunkedResults" :key="chunk.map((p) => p.id).join('')" class="col-12 col-md-3">
                <div class="">
                  <div class="align-items-center flex-column h-100 d-flex">
                    <div class="flex-grow-1 d-flex align-items-center">
                      <div class>
                        <div class="text-nowrap patient-item" v-for="p in chunk" :key="p.id">
                          <a href="javascript:void(0)" @click="select(p)" class="text-nowrap">{{ p.fullname }}</a>
                          <small class="text-muted ml-1" v-if="p.age">{{p.age}}</small>
                        </div>
                        <!-- :class="{'font-weight-bold':selected.id === p.id}" -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { PatientApi } from '@/services'
import Slider from '@/components/Slider'
import { Slide } from 'hooper'
import moment from 'moment'
export default {
  props: ['first', 'middle', 'last', 'email', 'phone'],
  components: { Slider, Slide },
  data() {
    return {
      term: '',
      isSearching: false,
      results: null,
      error: '',
      searchTimeout: null,
      selected: null,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['isIntegrationActive']),
    withFullname() {
      return this.results
        .map((p) => ({
          ...p,
          fullname: [p.firstname, p.middlename, p.lastname].join(' '),
          age: moment().diff(p.birthdate, 'year'),
        }))
        .sort((a, b) => a.fullname.localeCompare(b.fullname))
    },
    chunkedResults() {
      let arr = this.withFullname
      if (!arr || !arr.length) return []
      let chunked = []
      const perCol = Math.ceil(arr.length / 4)
      for (let i = 0; i < arr.length; i += perCol)
        chunked.push(arr.slice(i, i + perCol))
      return chunked
    },
  },
  async mounted() {
    this.$emit('searching', false)
    this.focusEl()
  },
  // watch: {
  //   searchTerm(newValue, old) {
  //     if (!newValue || newValue == old || this.selected) return;
  //     if (this.searchTimeout) clearTimeout(this.searchTimeout);
  //     this.searchTimeout = setTimeout(this.search.bind(this), 300);
  //   }
  // },
  methods: {
    async search() {
      if (this.term.length < 3) return
      this.results = null
      this.isSearching = true
      this.$emit('searching', true)
      try {
        let response = await PatientApi.get(
          'search-pms/' + encodeURIComponent(this.term)
        )
        this.results = response
      } catch (err) {
        this.error = (err && err.message) || 'Failed to search'
      }
      this.isSearching = false
    },
    focusEl() {
      this.$refs.searchInput.focus()
    },
    select(patient) {
      this.selected = patient
      this.$emit('patientSelected', patient)
    },
    clear(patient) {
      this.selected = null
      this.$emit('patientSelected', null)
      // this.$emit('searching', false);
    },
  },
}
</script>

<style scoped>
.patient-card {
  border: 1px solid #1cacda;
  height: 100%;
  cursor: pointer;
  position: relative;
}
.overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #ffffff60;
}
.patient-item {
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0.15rem;
  font-weight: 500;
}

.search-result-list {
  overflow: auto;
  max-height: 550px;
  padding-bottom: 80px !important;
}
</style>
